import { createContext, useContext } from 'react';

export const MapBearingContext = createContext(0);
export const useMapBearing = () => useContext(MapBearingContext);

export const MapZoomContext = createContext(18.5);
export const useMapZoom = () => useContext(MapZoomContext);
